var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmartMeter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.553,13.052H3.627V8.427H14.553Zm-9.81-1.116h8.694V9.542H4.743Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,16.875A7.875,7.875,0,1,1,16.875,9,7.875,7.875,0,0,1,9,16.875Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.485,5.774a1.973,1.973,0,0,0-2.791,0l-.509-.509a2.693,2.693,0,0,1,3.809,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.572,6.687a.7.7,0,0,0-.963,0L8.1,6.179a1.435,1.435,0,0,1,1.983,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4,4.861a3.265,3.265,0,0,0-4.617,0l-.509-.509a3.985,3.985,0,0,1,5.636,0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmartMeter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/smart-meter.89317b332659493d65432e4287eb4a94.svg";